export const automatedActivityTypes = [
    'CONVERSATION_CREATED_BY_CUSTOMER',
    'CONVERSATION_CREATED_BY_AGENT',
    'CONVERSATION_OFFERED',
    'CONVERSATION_CLOSED',
    'CONVERSATION_PENDING',
];
